import {
  ExternalOffenderChip,
  ExternalOffenderChipRemove,
  ExternalOffenderChips,
} from './DynamicQuestion.styles';

interface ExternalOffenderChipListProps {
  names: string[];
  onRemove: (name: string) => void;
  dataTestId: string;
}

export const ExternalOffenderChipList = ({
  names,
  onRemove,
  dataTestId,
}: ExternalOffenderChipListProps) => {
  if (names.length === 0) {
    return null;
  }

  return (
    <ExternalOffenderChips>
      {names.map((name, i) => (
        <ExternalOffenderChip key={`${name}-${i}`}>
          {name}
          <ExternalOffenderChipRemove
            type="button"
            onClick={() => onRemove(name)}
            data-testid={`${dataTestId}-remove-external-${name}`}
          >
            &times;
          </ExternalOffenderChipRemove>
        </ExternalOffenderChip>
      ))}
    </ExternalOffenderChips>
  );
};
